import { views } from 'spw-components/library/constants';
import * as libraryActions from './actions';
import { ILibraryState } from './types';

const initialState: ILibraryState = {
  activeAssetId: null,
  activeBuilding: null,
  activeFloor: null,
  isDownloading: false,
  projectLibrary: null,
  open: false,
  openLightbox: false,
  view: views.GALLERY,
  isLoadingProjectLibrary: false,
  isDownloadingBuildingNotes: false,
};

const reducer = (
  state: ILibraryState = initialState,
  action: libraryActions.Actions
): ILibraryState => {
  switch (action.type) {
    case libraryActions.FETCH_PROJECT_LIBRARY_SUCCESS:
      return {
        ...state,
        projectLibrary: action.payload.projectLibrary,
      };
    case libraryActions.SET_LOADING_PROJECT_LIBRARY: {
      const { isLoading } = action.payload;

      return {
        ...state,
        isLoadingProjectLibrary: isLoading,
      };
    }
    case libraryActions.SELECT_ASSET:
      return {
        ...state,
        activeAssetId: action.payload.assetId,
      };
    case libraryActions.SELECT_BUILDING: {
      const { buildingId, floorId } = action.payload;

      return {
        ...state,
        activeFloor: floorId,
        activeBuilding: state.projectLibrary?.buildings.find(
          (building: any) => buildingId === building.id
        ),
      };
    }
    case libraryActions.START_DOWNLOAD:
      return {
        ...state,
        isDownloading: action.payload.isDownloading,
      };
    case libraryActions.SWITCH_VIEW:
      return {
        ...state,
        view: action.payload.view,
      };
    case libraryActions.TOGGLE_LIBRARY:
      return {
        ...state,
        open: action.payload.open,
      };
    case libraryActions.TOGGLE_LIGHTBOX:
      return {
        ...state,
        openLightbox: action.payload.open,
      };
    case libraryActions.FETCH_BUILDING_NOTES_SPREADSHEET:
      return {
        ...state,
        isDownloadingBuildingNotes: true,
      };
    case libraryActions.FETCH_BUILDING_NOTES_SPREADSHEET_SUCCESS:
    case libraryActions.FETCH_BUILDING_NOTES_SPREADSHEET_FAILED:
      return {
        ...state,
        isDownloadingBuildingNotes: false,
      };
    default:
      return state;
  }
};

export default reducer;
